module.exports = __webpack_public_path__ + "img/img10.c90c9a71.svg";